<template>
  <v-container>
    <v-row>
      <v-col>
        <h4>WhatsApp Groups Fresh Programs</h4>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="6">
        <v-select
          v-model="selectedProgram"
          label="Programs"
          required
          clearable
          :items="programOptions"
          :disabled="loading"
          @change="
            results = [];
            loading = true;
          "
        />
      </v-col>
      <v-col cols="6">
        <v-select
          v-model="selectedGroupAdd"
          label="Added to Group"
          required
          clearable
          :items="addOptions"
          item-text="text"
          item-value="value"
          :disabled="loading"
          @change="
            results = [];
            loading = true;
          "
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="results"
      :items-per-page="50"
      :loading="loading"
      dense
      class="mt-2 elevation-2"
    >
      <template v-slot:item.userFullName="{ item }">
        <div>
          <router-link class="font-weight-bold" :to="`/clients/${item.userId}`">
            {{ item.userFullName }}
          </router-link>
        </div>
      </template>
      <template v-slot:item.addedToGroup="{ item }">
        <div>
          <v-select
            v-model="item.addedToGroup"
            required
            :items="addToGroupOptions"
            item-text="text"
            item-value="value"
            :disabled="loading"
            @change="updateAddToGroup(item)"
          />
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {
  WORKOUT_BLOCKS_QUERY,
  WORKOUT_SUBSCRIPTION_BLOCKS_QUERY,
  UPDATE_ADD_TO_GROUP_MUTATION,
} from "@/constants/graphql/workouts/workout";
import { decodeId } from "@/lib/string";
import { extractNodes } from "@/lib/array";

export default {
  name: "WhatsAppGroupsFreshPrograms",
  components: {},
  data() {
    return {
      addOptions: [
        { value: "ADDED", text: "Added" },
        { value: "UNABLE_TO_ADD", text: "Unable to Add" },
      ],
      addToGroupOptions: [
        { value: "ADDED", text: "Added" },
        { value: "UNABLE_TO_ADD", text: "Unable to Add" },
      ],
      programOptions: [],
      results: [],
      selectedGroupAdd: null,
      selectedProgram: null,
      subscriptionCursor: null,
      loading: true,
      headers: [
        { text: "Program", value: "program" },
        { text: "Name", value: "userFullName" },
        { text: "Phone Number", value: "userPhone" },
        { text: "Added to Group", value: "addedToGroup" },
        { text: "Start Date", value: "startDate" },
        { text: "End Date", value: "endDate" },
      ],
    };
  },
  methods: {
    decodeId(value) {
      return decodeId(value);
    },
    async updateAddToGroup(item) {
      this.loading = true;

      try {
        await this.$apollo.mutate({
          mutation: UPDATE_ADD_TO_GROUP_MUTATION,
          variables: {
            subscriptionBlockId: item.id,
            addedToGroup: item.addedToGroup,
          },
          refetchQueries: ["workoutSubscriptionBlocks"],
        });

        this.$toasted.success("Succefully updated. ", {
          duration: 2000,
          position: "bottom-center",
        });

        this.loading = false;
      } catch (e) {
        console.log(e);

        this.$toasted.error(
          "Unable to update at this time, please try again. ",
          {
            duration: 2000,
            position: "bottom-center",
          }
        );

        this.loading = false;
      }
    },
  },
  apollo: {
    workoutBlocks: {
      query: WORKOUT_BLOCKS_QUERY,
      fetchPolicy: "cache-and-network",
      variables: {
        orderBy: "title",
      },
      result(response) {
        if (response.data) {
          this.programOptions = extractNodes(
            response.data.workoutBlocks.edges
          ).map(({ title }) => title);
          return extractNodes(response.data.workoutBlocks.edges);
        }
      },
    },
    workoutSubscriptionBlocks: {
      query: WORKOUT_SUBSCRIPTION_BLOCKS_QUERY,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          orderBy: "-createdAt",
          block_Title: this.selectedProgram,
          addedToGroup: this.selectedGroupAdd,
        };
      },
      result(response) {
        if (response.data) {
          this.results = response.data.workoutSubscriptionBlocks.edges.map(
            (item) => {
              return {
                id: this.decodeId(item.node.id),
                program: item.node.block.title,
                userId: item.node.user.id,
                userFullName: `${item.node.user.firstName} ${item.node.user.lastName}`,
                userPhone: item.node.user.userProfile?.phone,
                addedToGroup: item.node.addedToGroup,
                startDate: item.node.startDate
                  ? this.$moment(item.node.startDate).format("YYYY-MM-DD")
                  : "",
                endDate: item.node.endDate
                  ? this.$moment(item.node.endDate).format("YYYY-MM-DD")
                  : "",
              };
            }
          );

          setTimeout(() => {
            this.loading = false;
          }, 2000);
        }
      },
    },
  },
};
</script>
<style scoped>
::v-deep thead th {
  height: 50px !important;
  font-size: 15px;
  background: #cfcfcf;
  padding: 20px;
}
</style>
